module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Thin.woff
// module id = 54
// module chunks = 8